<template>
  <layout-popup>
    <div style="height: 100%; overflow: auto">
      <v-card-text>
        <p class="subtitle-2">
          The value saved in the objects themselves will be lost. This change is
          irreversible.
        </p>

        <span class="subtitle-2">
          Apply default value to all existing objects?
        </span>
      </v-card-text>
    </div>
    <template slot="footer">
      <v-spacer></v-spacer>
      <v-btn text @click="$emit('close')">Cancel</v-btn>
      <v-btn color="primary" text @click="applyDefaultValues">Apply</v-btn>
    </template>
  </layout-popup>
</template>

<script>
import LayoutPopup from '@/layouts/LayoutPopup';
import { reactive, toRefs } from '@vue/composition-api';
import { useMutation } from '@vue/apollo-composable';
import schemas from '@/api/objects/schemas.graphql';

export default {
  components: {
    LayoutPopup
  },
  name: 'ApplyDefaultValue',
  props: {
    entity: {
      type: Object,
      default: () => ({})
    },
    context: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props, { emit }) {
    const { mutate: applyToMany } = useMutation(schemas.applyToMany);

    const localState = reactive({
      schemaName: '',
      tags: [],
      description: ''
    });

    const applyDefaultValues = () => {
      applyToMany({
        input: {
          propertiesArray: [
            {
              propertyId: props.context.raw.id,
              value: props.context.raw.defaultValue
            }
          ],
          propertiesByKeyArray: [
            {
              propertyKey: props.context.raw.key,
              value: props.context.raw.defaultValue
            }
          ],
          valueInit: true,
          schemaId: props.entity.id
        }
      }).then(() => {
        emit('close');
      });
    };

    return {
      ...toRefs(localState),
      applyDefaultValues
    };
  }
};
</script>
